@if (jmapParameters && jmapParameters.areCredentialsSet) {
  <div id="jmap-div">
    <iframe #jmap id="jmap" [src]="jmapPanelContent" [title]="'TITLE.JMAP' | translate"></iframe>
  </div>
} @else if (jmapParameters && !jmapParameters.areCredentialsSet) {
  <div id="no-jmap-configuration-container" class="fx-layout-col fx-justify-center fx-align-center fx-gap-25">
    <mat-icon fontSet="material-icons" fontIcon="warning" id="warning-icon"></mat-icon>
    <h4 id="no-jmap-configuration-message">
      {{ "LABEL.NO_JMAP_CONFIGURATION" | translate }}
    </h4>
  </div>
} @else {
  <spinner></spinner>
}

